module.exports = __webpack_public_path__ + "img/rlight.cd7e30bb.png";